import Vue from "vue";
import vuexI18n from "vuex-i18n";
import translationEn from './en.js';
import translationIs from './is.js';

import store from '../store';

Vue.use(vuexI18n.plugin, store);

Vue.i18n.add('en', translationEn);
Vue.i18n.add('is', translationIs);

Vue.i18n.set('en');

export default store;